import { render, staticRenderFns } from "./OfferMy.vue?vue&type=template&id=2d616cd4&scoped=true&"
import script from "./OfferMy.vue?vue&type=script&lang=js&"
export * from "./OfferMy.vue?vue&type=script&lang=js&"
import style0 from "./OfferMy.vue?vue&type=style&index=0&id=2d616cd4&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2d616cd4",
  null
  
)

export default component.exports